import { EVENT_DAILY_REWARD_MODAL_CLOSED, EVENT_DAILY_REWARD_MODAL_OPENED } from "../constants";

/**
 * Singleton class to track daily reward modal open status.
 * Tracks state via events to avoid DOM queries and ensure React state synchronization.
 * Follows the same singleton pattern used throughout the codebase (Logger, DepositFunnelTracker, etc.)
 */
export class DailyRewardModalTracker {
  private static instance: DailyRewardModalTracker | null = null;
  private isModalOpen = false;
  private handleOpened: () => void;
  private handleClosed: () => void;

  private constructor() {
    // Initialize event handlers
    this.handleOpened = () => {
      this.isModalOpen = true;
    };

    this.handleClosed = () => {
      this.isModalOpen = false;
    };

    // Set up event listeners
    window.addEventListener(EVENT_DAILY_REWARD_MODAL_OPENED, this.handleOpened);
    window.addEventListener(EVENT_DAILY_REWARD_MODAL_CLOSED, this.handleClosed);
  }

  static getInstance(): DailyRewardModalTracker {
    if (!DailyRewardModalTracker.instance) {
      DailyRewardModalTracker.instance = new DailyRewardModalTracker();
    }
    return DailyRewardModalTracker.instance;
  }

  /**
   * Checks if the daily reward modal is currently open.
   * @returns boolean indicating if the daily reward modal is currently open
   */
  isOpen(): boolean {
    return this.isModalOpen;
  }

  /**
   * Cleanup method to remove event listeners (useful for testing or cleanup scenarios).
   * Note: In normal operation, listeners persist for the app lifetime.
   */
  cleanup(): void {
    window.removeEventListener(EVENT_DAILY_REWARD_MODAL_OPENED, this.handleOpened);
    window.removeEventListener(EVENT_DAILY_REWARD_MODAL_CLOSED, this.handleClosed);
  }
}
